import KBArticle from 'conversations-visitor-experience-components/knowledge-base/KBArticle';
import { useKBArticle } from '../kbArticleSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
function KBArticleContainer() {
  const kbArticle = useKBArticle();
  return /*#__PURE__*/_jsx(KBArticle, {
    kbArticle: kbArticle
  });
}
KBArticleContainer.displayName = 'KBArticleContainer';
export default KBArticleContainer;